import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';
import { capitalizeFirstLetter } from '../pages/attendee/detail/components/utils';
import i18n from 'i18next/index';

export default class ModerationAttendeeComment extends BaseAPIModel {
    fields() {
        return {
            uuid: { primaryKey: true, readOnly: true },
            name: {}
        };
    }

    // TODO: handle limit/offset rules
    static listUrl({ organizationId, flowId, attendeeId }) {
        if (!organizationId || !attendeeId) {
            throw new ArgumentError(`[Model][AttendeeComment][getAll] organizationId and attendeeId are mandatory`);
        }

        if (!flowId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/attendees/${attendeeId}/comments`;
        }
        return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/attendees/${attendeeId}/comments`;
    }

    static create({ organizationId, flowId, attendeeId, comment }) {
        if (!organizationId || !attendeeId) {
            throw new ArgumentError(`[Model][AttendeeComment][getAll] organizationId and attendeeId are mandatory`);
        }

        return this.fetcher
            .post(`/ticket/organizations/${organizationId}/moderation_flows/attendees/${attendeeId}/create_comment`, {
                data: {
                    comment
                }
            })
            .then(response => {})
            .catch(error => {})
            .finally(response => {});
    }

    get resolved_user_name() {
        if (this.object.user.last_name || this.object.user.first_name) {
            return `${capitalizeFirstLetter(this.object.user.first_name)} ${capitalizeFirstLetter(this.object.user.last_name)}`;
        }
        return i18n.t('ticket.manager.nonNominative');
    }
}
